export default "<app-movie-nav [items]=\"categories\" [startIndex]=\"startIndex\" (change)=\"onChange($event)\"></app-movie-nav>"